import type { UserTokenSpendDTO } from '@api/fastAPI.schemas'

export const periodConfig = {
  month: { label: 'Dieser Monat' },
  last30Days: { label: '30 Tage' },
  last90Days: { label: '90 Tage' },
  allTime: { label: 'Gesamt' },
}

export type Period = keyof typeof periodConfig

const DAY_MS = 24 * 60 * 60 * 1000

/** Start of the period as ISO timestamp, undefined for all time. */
export const periodStart = (period: Period, now: Date = new Date()): string | undefined => {
  switch (period) {
    case 'month':
      return new Date(now.getFullYear(), now.getMonth(), 1).toISOString()
    case 'last30Days':
      return new Date(now.getTime() - 30 * DAY_MS).toISOString()
    case 'last90Days':
      return new Date(now.getTime() - 90 * DAY_MS).toISOString()
    case 'allTime':
      return undefined
  }
}

const costFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const tokenFormatter = new Intl.NumberFormat('de-DE')

const compactTokenFormatter = new Intl.NumberFormat('de-DE', {
  notation: 'compact',
  maximumFractionDigits: 1,
})

export const formatCost = (costUsd: number): string => costFormatter.format(costUsd)

export const formatTokens = (tokens: number): string => tokenFormatter.format(tokens)

export const formatCompactTokens = (tokens: number): string => compactTokenFormatter.format(tokens)

export interface TokenSpendTotals {
  costUsd: number
  inputTokens: number
  outputTokens: number
  runs: number
  runsWithoutCost: number
}

export const sumTokenSpend = (users: UserTokenSpendDTO[]): TokenSpendTotals =>
  users.reduce<TokenSpendTotals>(
    (totals, user) => ({
      costUsd: totals.costUsd + user.cost_usd,
      inputTokens: totals.inputTokens + user.input_tokens,
      outputTokens: totals.outputTokens + user.output_tokens,
      runs: totals.runs + user.runs,
      runsWithoutCost: totals.runsWithoutCost + user.runs_without_cost,
    }),
    { costUsd: 0, inputTokens: 0, outputTokens: 0, runs: 0, runsWithoutCost: 0 },
  )
